import { Badge } from "@altimateai/lego";
import { AUTO_TUNE_MAP, AUTO_TUNE_STATUS } from "../pages/warehouse/constants";

interface AutoSavingsStatusProps {
  autoTuneStatus: AUTO_TUNE_STATUS;
}

// Uses `variant="outline"` — the only Badge variant that ships without a
// `hover:al-bg-*` rule, so the bg can't darken under the static colour
// (the prior `success` / `destructive` variants caused a contrast clash
// on hover because the text colour didn't move). Border is forced
// transparent so the pill still reads as a filled chip, not a stroked
// outline.
const AutoSavingsStatus = ({ autoTuneStatus }: AutoSavingsStatusProps) => {
  const isEnabled = autoTuneStatus === "auto-tune-enabled";
  return (
    <Badge
      variant="outline"
      interactive={false}
      // `!al-text-*` forces the status color to win over the `outline`
      // variant's `al-text-foreground`. tailwind-merge does not dedupe
      // `al-`-prefixed classes, so the variant's text colour would
      // otherwise leak through and the chip could pick up the foreground
      // colour depending on CSS source order.
      className={
        isEnabled
          ? "al-bg-green-100 !al-text-green-500 al-border-transparent"
          : "al-bg-red-100 !al-text-action-red al-border-transparent"
      }
    >
      {AUTO_TUNE_MAP[autoTuneStatus].text}
    </Badge>
  );
};

export default AutoSavingsStatus;
